var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"t2d-app"},[_c('div',{staticClass:"layout"},[(!_vm.hideAppBar)?_c('AppHeader'):_vm._e(),_c('v-main',{staticClass:"layout-main"},[_c('router-view',{key:_vm.$route.fullPath})],1),(!_vm.hideAppBar)?_c('ShareBar'):_vm._e(),(!_vm.hideAppBar)?_c('Footer'):_vm._e()],1),_c('CookieBanner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }